const NAVIGATION_FALLBACK_EVENT = 'navigation:fallback';

const emitFallbackEvent = (url) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(NAVIGATION_FALLBACK_EVENT, {
      detail: { url },
    }),
  );
};

export const openUrl = (url, { preferSameTab = true } = {}) => {
  if (typeof window === 'undefined' || !url) {
    return { openedInNewTab: false, usedFallback: false };
  }

  const popup = window.open(url, '_blank', 'noopener,noreferrer');
  if (popup) {
    return { openedInNewTab: true, usedFallback: false };
  }

  if (preferSameTab) {
    emitFallbackEvent(url);
    window.location.assign(url);
    return { openedInNewTab: false, usedFallback: true };
  }

  return { openedInNewTab: false, usedFallback: false };
};

export const onNavigationFallback = (handler) => {
  if (typeof window === 'undefined' || typeof handler !== 'function') {
    return () => {};
  }

  const listener = (event) => handler(event?.detail || {});
  window.addEventListener(NAVIGATION_FALLBACK_EVENT, listener);
  return () => window.removeEventListener(NAVIGATION_FALLBACK_EVENT, listener);
};
